module.exports = __webpack_public_path__ + "static/img/bgphone-new-fb.cf9a4f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/bgphone-new-fb.png
// module id = G/01
// module chunks = 1